import React from "react";
export default class FormInput extends React.Component {
  render() {
    if (this.props.type === "select") {
      return (
        <div>
          <select
            value={this.props.value}
            name={this.props.name}
            onChange={this.props.onChange}
            style={{
              border: "none",
              borderRadius: 5,
              height: 50,
              textIndent: 20,
              fontSize: 12,
              backgroundColor: "#fff",
              ...(this.props.styles || {}),
            }}
          >
            {this.props.options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <span
            style={{
              display: "flex",
              width:"80%",
              margin: "0 auto 10px",
              fontSize: 11,
            }}
            dangerouslySetInnerHTML={{__html:this.props.suggestionText || ""}}>
          </span>
        </div>
      );
    }
    
    return (
      <div>
        <input
          type={this.props.type || "text"}
          value={this.props.value}
          name={this.props.name}
          onChange={this.props.onChange}
          placeholder={this.props.placeholder}
          maxLength={this.props.maxLength}
          style={{
            border: "none",
            borderRadius: 5,
            height: 50,
            textIndent: 20,
            fontSize: 12,
            ...(this.props.styles || {}),
          }}
        />
        <span
          style={{
            display: "flex",
            width:"80%",
            margin: "0 auto 10px",
            fontSize: 11,
          }}
          dangerouslySetInnerHTML={{__html:this.props.suggestionText || ""}}>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/Input.js